import * as Yup from 'yup';
import { phoneNumberFormatter } from './phoneNumber.validation';

export const PlanUpgradeModalSchema = Yup.object().shape({
  contactNumber: Yup.string()
    .label('Your contact number')
    .max(16, 'Maximum 16 Characters.')
    .required()
    .test(
      'validate-cpnumber',
      'Please enter a valid phone number',
      (value): any => {
        return phoneNumberFormatter({ phoneNumber: value || '' }).isValid();
      }
    )
});
